import axios from "axios";
import auth from "../../utils/auth";
import tracking from "../../utils/analytics";

const state = {
	list: [],
	seen: false,
	addedToBetslip: [],
	isLoading: false,
};
const getters = {
	list: (state) => state.list,
	addedToBetslip: (state) => state.addedToBetslip,
	isLoading: (state) => state.isLoading,
};
const mutations = {
	FETCH_RECOMMEDATIONS(state, list) {
		state.list = list;
	},
	SAVE_SEEN_RECOMMENDATIONS(state) {
		state.seen = true;
	},
	ADDED_TO_BETSLIP(state, bet) {
		state.addedToBetslip.push(bet);
	},
	REMOVED_FROM_BETSLIP(state, removedBet) {
		// get index of bet
		let betIndex = state.addedToBetslip.findIndex(function(bet) {
			return bet.parent_match_id == removedBet.parent_match_id;
		});
		state.addedToBetslip.splice(betIndex, 1, removedBet);
	},
	CLEAR_ADDED_TO_BETSLIP(state) {
		state.addedToBetslip = [];
	},
	LOADING_STATUS(state, status) {
		state.isLoading = status;
	},
};
const actions = {
	async getRecommendations(store, params) {
		const details = auth.getUser();

		if (details) {
			const profile_id = details.id;

			store.commit("LOADING_STATUS", true);

			const recommendationIDs = await axios.get(
				`${RECOMMEDATIONS_API_URL}pre-bet?widget=betslip-pre&user_id=${profile_id}&event_ids=${params.event_ids}`
			);

			if (recommendationIDs.data.length !== 0) {
				let recommendationIds = [];

				recommendationIDs.data.forEach(function(ids) {
					recommendationIds.push(ids);
				});

				const recommendationsData = await axios.get(
					`${BASE_URL}uo/bulk-match?ids=${recommendationIds.join()}&stids=1,186,340`
				);

				store.commit("FETCH_RECOMMEDATIONS", recommendationsData.data.data);
				if (recommendationsData.data.data.length > 0 && !store.state.seen) {
					tracking.recommendations.see({
						ids: recommendationsData.data.data.map(
							(rec) => rec.parent_match_id
						),
					});
					store.commit("SAVE_SEEN_RECOMMENDATIONS", []);
				}
			} else {
				store.commit("FETCH_RECOMMEDATIONS", []);
			}
			store.commit("LOADING_STATUS", false);
		}
	},
	trackPlaceBet({ commit, state }, params) {
		//use this in betslip
		const ref = params.ref;
		const ids = state.addedToBetslip;
		tracking.recommendations.place({ ref, ids });

		commit("CLEAR_ADDED_TO_BETSLIP", []);
	},
	getAddedRecommendations({ commit }, bet) {
		commit("LOADING_STATUS", true);
		commit("ADDED_TO_BETSLIP", bet);
	},
	removeAddedRecommendations({ commit }, bet) {
		commit("LOADING_STATUS", true);
		commit("REMOVED_FROM_BETSLIP", bet);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
